import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { FlexLayoutModule } from 'ngx-flexible-layout';

import { NotFoundComponent } from './not-found/not-found.component';
import { SessionsRoutes } from './sessions.routing';
import { SharedMaterialModule } from '../../shared/shared-material.module';
import { LogoutComponent } from './logout/logout.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedMaterialModule,
    FlexLayoutModule,
    RouterModule.forChild(SessionsRoutes)
  ],
  declarations: [NotFoundComponent, LogoutComponent]
})
export class SessionsModule {
}
